import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

export type GetClusterStoreModalPaginationState = {
  activePage: number;
  displayLength: number;
};

const initialState: GetClusterStoreModalPaginationState = {
  activePage: 0,
  displayLength: 25,
};

const slice = createSlice({
  name: 'getClusterStoreModal/pagination',
  initialState,
  reducers: {
    SET_GET_CLUSTER_STORE_MODAL_PAGINATION: (_state, { payload }: PayloadAction<GetClusterStoreModalPaginationState>) => payload,
    UPDATE_GET_CLUSTER_STORE_MODAL_PAGINATION: (state, { payload }: PayloadAction<Partial<GetClusterStoreModalPaginationState>>) => {
      return {
        ...state,
        ...payload,
      };
    },
    SET_GET_CLUSTER_STORE_MODAL_DISPLAY_LENGTH: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        displayLength: payload,
      };
    },
    SET_GET_CLUSTER_STORE_MODAL_ACTIVE_PAGE: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        activePage: payload,
      };
    },
    RESET_GET_CLUSTER_STORE_MODAL_PAGINATION: () => initialState,
  },
});

export const {
  SET_GET_CLUSTER_STORE_MODAL_PAGINATION,
  UPDATE_GET_CLUSTER_STORE_MODAL_PAGINATION,
  SET_GET_CLUSTER_STORE_MODAL_DISPLAY_LENGTH,
  SET_GET_CLUSTER_STORE_MODAL_ACTIVE_PAGE,
  RESET_GET_CLUSTER_STORE_MODAL_PAGINATION,
} = slice.actions;

export const selectorGetClusterStoreModalPagination = (state: RootState) => {
  return state.getClusterStoreModalReducer.pagination;
};

export default slice.reducer;
